import { DialogDescription, DialogHeader, DialogTitle } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { useNomenclatureData } from '@/hooks';
import { TFormData } from '.';

const FormEditOrAssignPermissionsHeader = () => {

  const { control } = useFormContext<TFormData>();
  const { selectOptions } = useNomenclatureData('AdminUserPermissionsEnum');
  const permissions = useWatch({ control, name: 'roles.permissions' });
  const username = useWatch({ control, name: 'username' });
  const email = useWatch({ control, name: 'email' });

  return (
    <DialogHeader>
      <DialogTitle>
        {username}
      </DialogTitle>
      <DialogDescription>
        {email} • (<span className='text-purple-600'>{new Set((permissions ?? []).filter(p => selectOptions.some(o => o.value === p))).size}/{selectOptions.length}</span>) Permission(s)
      </DialogDescription>
    </DialogHeader>
  );
};

export default FormEditOrAssignPermissionsHeader;
